import React from 'react';
import {
  CalendarIcon,
  MessageIcon,
  PhoneRightIcon,
  PreferredContactIcon,
  StarIcon,
} from 'components/common/SVGIcon';
import { getDisplayAddress } from 'utils/dataUtils';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'utils/tools';
import { FORMAT_DATE_PICKER } from 'configs/localData/constant';
import { EnvironmentOutlined } from '@ant-design/icons';
import ContactInfoItem from '../ContactInfoItem';

const ParentContact = ({ title, item }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="text-20 fw-bold">
        <div className="text-primary leading-7">{t(title)}</div>
        <div className="text-black-base mt-12">{`${item?.firstName} ${item?.lastName}`}</div>
      </div>

      <Space className="flex mt-12" direction="vertical" size={16}>
        <ContactInfoItem
          value={formatDate(item?.dateOfBirth, FORMAT_DATE_PICKER)}
          icon={<CalendarIcon />}
        />
        <ContactInfoItem value={item?.phoneNumber} icon={<PhoneRightIcon />} />
        <ContactInfoItem
          value={item?.email}
          icon={<MessageIcon />}
          className="break-all"
        />
        <ContactInfoItem
          value={
            item?.centrelinkCRN && `${item?.centrelinkCRN} - Centrelink CRN`
          }
          icon={<StarIcon />}
        />
        <ContactInfoItem
          value={getDisplayAddress(item)}
          icon={<EnvironmentOutlined />}
        />
        <ContactInfoItem
          value={item?.preferredContactMethod}
          icon={<PreferredContactIcon />}
        />
      </Space>
    </div>
  );
};

export default ParentContact;
